export default {
    2: 'BUYER',
    3: 'BANDS',
    1: 'SELLER',
    5: 'RENTAL',
    '-1': 'OTHER'
};
